import styled from 'styled-components';

export const Wrapper = styled.div<{ background?: string }>`
  width: 100%;
  background-color: ${({ background }) => background || 'inherit'};
`;
